module.exports = __webpack_public_path__ + "img/img1.551aaa4c.png";